// Returns a random value based on a probability map
function ProbabilityMap(map)
{
  this.array = [];
  for (var prop in map)
  {
    for (var i = 0; i < map[prop]; i++)
    {
      this.array.push( prop );
    }
  }
  this.shuffle();
}

ProbabilityMap.prototype = 
{
  random: function()
  {
    if (this.takes === this.array.length)
    {
      this.shuffle();
    }

    return this.array[ this.takes++ ];
  },
  shuffle: function()
  {
    for (var j, x, i = this.array.length; i; j = Math.floor(Math.random() * i), x = this.array[--i], this.array[i] = this.array[j], this.array[j] = x);
    this.takes = 0;
  },
  buffer: function(fromValue, places)
  {
    var arr = this.array;
    var n = arr.length;
    var safe = {min: places, max: n};

    for (var i = 0; i < places; i++)
    {
      if ( arr[ i ] === fromValue )
      {
        var nextIndex = i;

        while ( arr[nextIndex] === fromValue )
        {
          nextIndex = Math.floor( Random( safe ) );
        }

        var next = arr[ nextIndex ];
        arr[ nextIndex ] = arr[ i ];
        arr[ i ] = next;
      }
    }
  }
};